/**
 * useSalonEmployees Hook
 */

import { useState, useEffect, useCallback } from 'react';
import { getSalonEmployees } from '../../services/coursesService';
import type { SalonEmployee } from '../../types/courses.types';

interface UseSalonEmployeesResult {
  isLoading: boolean;
  error: string | null;
  employees: SalonEmployee[];
  salonName: string | null;
  refresh: () => void;
}

export function useSalonEmployees(
  employeeId: number | null,
  isOwner: boolean,
  isAuthenticated: boolean
): UseSalonEmployeesResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [employees, setEmployees] = useState<SalonEmployee[]>([]);
  const [salonName, setSalonName] = useState<string | null>(null);

  const fetchEmployees = useCallback(async () => {
    if (!employeeId || !isAuthenticated || !isOwner) return;
    setIsLoading(true);
    setError(null);
    try {
      const { employees: list, salonName: name } = await getSalonEmployees();
      setEmployees(list);
      setSalonName(name);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Der opstod en fejl');
    } finally {
      setIsLoading(false);
    }
  }, [employeeId, isAuthenticated, isOwner]);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  return { isLoading, error, employees, salonName, refresh: fetchEmployees };
}
